@if (pushBannerData?.tag) {
  <sd-tag
    [brand]="brand"
    [isCopyTag]="isCopyTag"
    [tagData]="pushBannerData?.tag"
    (copied)="onCopied($event)"
  />
}

<div class="c__content">
  @if (pushBannerData?.title) {
    <sd-title [titleLevel]="titleLevel" customClass="is-body-m c__main-title">
      {{ pushBannerData?.title }}
    </sd-title>
  }

  @if (pushBannerData?.details) {
    <span class="c__tooltip-wrapper">
      <sd-tooltip [position]="isMobile$ ? positionEnum.top : positionEnum.bottom">
        <span class="is-caption is-bold is-underline c__terms">{{ 'CmsComponent.PromoBanner.offerTerms' | translate }}</span>
        <sd-icon name="icon-help" [size]="iconSize.small" />
        <ng-container sd-tooltip-template>
          <sd-html [html]="pushBannerData?.details" tag="div" />
        </ng-container>
      </sd-tooltip>
    </span>
  }
</div>

@if (pushBannerData?.links?.length > 0) {
  <div class="c__links">
    @for (link of pushBannerData?.links; track link) {
      <sd-link
        (clicked)="onClickPromoLink($event)"
        [isButton]="true"
        [theme]="themesEnum.light"
        [isSmall]="true"
        [link]="link"
      >
        {{ link?.linkName}}
      </sd-link>
    }
  </div>
}

@if (pushBannerData?.media) {
  <sd-banner
    class="is-main"
    [media]="pushBannerData.media"
    [hasAltText]="false"
    [twicPicsAutoSize]="twicPicsAutoSize"
  />
}
